<template>
  <div class="series">
    <h1>车系页面</h1>
    <p>这是车系展示页面，实际开发中会显示所有汽车车系</p>
  </div>
</template>

<script>
export default {
  name: 'Series'
}
</script>

<style scoped>
.series {
  padding: 20px;
}
</style> 